class WohlFuhlMobileMenu extends HTMLElement {
  connectedCallback() {
    if (this.controller) return;
    this.controller = new AbortController();
    document.addEventListener('click', event => {
      if (!(event.target instanceof Element) || !event.target.closest('a[href="#nav"]')) return;
      const menu = document.getElementById('nav');
      const root = menu?.querySelector('.mm-panels > .mm-panel');
      const jquery = window.jQuery;
      const api = menu && jquery?.(menu).data('mmenu');
      if (root && api) api.openPanel(jquery(root), false);
    }, { capture: true, signal: this.controller.signal });
  }

  disconnectedCallback() {
    this.controller?.abort();
    this.controller = null;
  }
}

if (!customElements.get('wm-mobile-menu')) customElements.define('wm-mobile-menu', WohlFuhlMobileMenu);
